import { MutationHookOptions, useMutation } from "@apollo/client";
import askProductQuestionGQL from "@whoppah/apollo/mutation/askProductQuestion.graphql";

import {
  AskProductQuestionMutation,
  AskProductQuestionMutationVariables,
} from "@/Apollo/schema";

/**
 * Hook for asking a seller a question.
 * @param options - Hook typing options.
 * @returns Mutation tuple, with executable calls.
 */

export const useAskSellerQuestion = (
  options?: MutationHookOptions<
    AskProductQuestionMutation,
    AskProductQuestionMutationVariables
  >
) => {
  return useMutation(askProductQuestionGQL, options);
};
